/* Saucy cart: update quantities, remove items and add upsells without reloading the page.
   The free shipping bar slides smoothly from its old position to the new one. */
(function () {
  'use strict';
  var root = document.querySelector('[data-cart]');
  if (!root || !window.fetch || !window.DOMParser) return;

  var sectionEl = root.closest('.shopify-section');
  var sectionId = sectionEl && sectionEl.id ? sectionEl.id.replace(/^shopify-section-/, '') : null;
  if (!sectionId) return;

  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false, queue = null, timers = {};
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var inCart = function (el) { return el && root.contains(el); };

  /* ---------- checkout gate + discount code (re-bound after every update) ---------- */
  function gateRefresh() {
    var gates = $$('[data-gate]'), checkout = root.querySelector('[data-checkout]'), msg = root.querySelector('[data-gate-msg]');
    var ok = gates.length > 0 && gates.every(function (g) { return g.checked; });
    if (checkout) checkout.disabled = !ok;
    if (msg) msg.hidden = ok;
  }

  /* ---------- talk to Shopify ---------- */
  function post(path, body) {
    body.sections = sectionId;
    body.sections_url = window.location.pathname;
    return fetch(base + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function run(task) {
    if (busy) { queue = task; return; }
    busy = true;
    root.classList.add('is-updating');
    task().then(function (data) {
      if (data && data.sections && data.sections[sectionId]) swap(data.sections[sectionId]);
      if (data && typeof data.item_count === 'number') updateHeader(data.item_count);
    }).catch(function () {
      window.location.reload(); /* fall back to a normal refresh if anything goes wrong */
    }).then(function () {
      busy = false;
      root.classList.remove('is-updating');
      if (queue) { var next = queue; queue = null; run(next); }
    });
  }

  /* after add.js, ask for the fresh section separately */
  function addVariant(id) {
    run(function () {
      return fetch(base + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: sectionId, sections_url: window.location.pathname })
      }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function (data) {
          return fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
            .then(function (cart) { cart.sections = data.sections; return cart; });
        });
    });
  }

  function changeLine(key, qty) {
    run(function () { return post('cart/change.js', { id: key, quantity: qty }); });
  }

  /* ---------- swap in the new cart, animating the free shipping bar ---------- */
  function barState(scope) {
    var bar = scope.querySelector('.sc-progress__bar');
    if (!bar) return null;
    var fill = bar.querySelector('span'), dot = bar.querySelector('b');
    return { fill: fill ? fill.style.width : '0%', dot: dot ? dot.style.left : '0%', free: !!scope.querySelector('.sc-progress.is-free') };
  }

  function swap(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart]');
    if (!fresh) { window.location.reload(); return; }

    var before = barState(root);
    var checked = {};
    $$('[data-gate]').forEach(function (g) { checked[g.name] = g.checked; });
    var note = root.querySelector('textarea[name="note"]');
    var noteVal = note ? note.value : null;

    root.innerHTML = fresh.innerHTML;

    $$('[data-gate]').forEach(function (g) { if (checked[g.name]) g.checked = true; });
    var newNote = root.querySelector('textarea[name="note"]');
    if (newNote && noteVal !== null) newNote.value = noteVal;
    gateRefresh();

    var bar = root.querySelector('.sc-progress__bar');
    if (bar && before) {
      var fill = bar.querySelector('span'), dot = bar.querySelector('b');
      var toFill = fill ? fill.style.width : null, toDot = dot ? dot.style.left : null;
      bar.classList.add('no-anim');
      if (fill) fill.style.width = before.fill;
      if (dot) dot.style.left = before.dot;
      void bar.offsetWidth; /* lock in the old position */
      bar.classList.remove('no-anim');
      requestAnimationFrame(function () {
        if (fill) fill.style.width = toFill;
        if (dot) dot.style.left = toDot;
      });
      var prog = root.querySelector('.sc-progress');
      if (prog && !before.free && prog.classList.contains('is-free')) {
        prog.classList.add('just-unlocked');
        setTimeout(function () { prog.classList.remove('just-unlocked'); }, 1200);
      }
    }
  }

  function updateHeader(count) {
    document.querySelectorAll('a[href$="/cart"]').forEach(function (a) {
      if (root.contains(a)) return;
      var badge = a.querySelector('.sc-count');
      a.setAttribute('aria-label', 'cart, ' + count + ' items');
      if (count > 0) {
        if (!badge) { badge = document.createElement('span'); badge.className = 'sc-count'; a.appendChild(badge); }
        badge.textContent = count;
      } else if (badge) { badge.remove(); }
    });
  }

  /* ---------- events (captured here so the old reload-the-page handlers never run) ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty] [data-step]');
    if (step && inCart(step)) {
      e.preventDefault(); e.stopPropagation();
      var input = step.closest('[data-qty]').querySelector('input');
      var v = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.step, 10));
      input.value = v;
      schedule(input);
      return;
    }
    var add = e.target.closest('[data-add-variant]');
    if (add && inCart(add)) {
      e.preventDefault(); e.stopPropagation();
      add.disabled = true; add.textContent = 'adding…';
      addVariant(parseInt(add.dataset.addVariant, 10));
      return;
    }
    var remove = e.target.closest('a[href*="/cart/change"]');
    if (remove && inCart(remove)) {
      var line = remove.closest('.sc-line'), input2 = line && line.querySelector('[data-qty] input');
      if (input2) {
        e.preventDefault(); e.stopPropagation();
        line.classList.add('is-removing');
        changeLine(input2.id.replace(/^updates_/, ''), 0);
      }
      return;
    }
    var apply = e.target.closest('[data-apply-code]');
    if (apply && inCart(apply)) {
      e.preventDefault(); e.stopPropagation();
      var code = (root.querySelector('[data-code]') || {}).value;
      code = code ? code.trim() : '';
      if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root.dataset.cartUrl || '/cart');
    }
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!inCart(t)) return;
    if (t.matches('[data-qty] input')) { e.stopPropagation(); schedule(t); return; }
    if (t.matches('[data-gate]')) { e.stopPropagation(); gateRefresh(); }
  }, true);

  /* move the bar right away (before Shopify answers) so it feels instant */
  function nudgeBar() {
    var bar = root.querySelector('.sc-progress__bar');
    if (!bar) return;
    var max = parseInt(bar.getAttribute('aria-valuemax'), 10) || 2;
    var total = $$('[data-qty] input').reduce(function (n, i) { return n + (parseInt(i.value, 10) || 0); }, 0);
    var pct = Math.min(100, Math.round(total * 100 / max)) + '%';
    var fill = bar.querySelector('span'), dot = bar.querySelector('b');
    if (fill) fill.style.width = pct;
    if (dot) dot.style.left = pct;
  }

  /* wait a moment so quick taps on + become one update */
  function schedule(input) {
    nudgeBar();
    var key = input.id.replace(/^updates_/, '');
    clearTimeout(timers[key]);
    timers[key] = setTimeout(function () {
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      if (qty === 0) { var line = input.closest('.sc-line'); if (line) line.classList.add('is-removing'); }
      changeLine(key, qty);
    }, 350);
  }

  /* save the order note without a page reload */
  document.addEventListener('focusout', function (e) {
    var t = e.target;
    if (inCart(t) && t.matches('textarea[name="note"]')) {
      fetch(base + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: t.value }) });
    }
  }, true);

  gateRefresh();
})();
